import { browserAgent } from './agent';

export const captureError = (
  error: Error,
  customAttributes?: Record<string, string | number | boolean>,
): void => {
  browserAgent.noticeError(error, customAttributes);
};
